
export default {
  navbar: {
    home: "主页",
    about: "关于我们",
    newsCenter: "新闻中心",
    ourServices: "我们的服务",
    contactUs: "联系我们",
    Services1: "银行授信担保",
    Services2: "固定资产投资",
    Services3: "数字资产投资",
    Services4: "人工智能应用",
  },
  footer: {
    contact: "联系信息",
    DUBAIOffice: "迪拜公司",
    DUBAIAdress:
      "地址：Villa 17, 31a St, Al Barsha 3,Dubai,UAE.",
    DUBAIEmail: "邮箱：info@blacklocustcap.com",
    DUBAIPhone: "电话：+971 43 865 810",
    CHINAOffice: "中国公司",
    CHINAAdress: "地址：中国上海市南京西路1376号上海商城西栋527室",
    CHINAEmail: "邮箱：info@blacklocustcap.com",
    CHINAContactPerson: "联系人：Fred",
    CHINAContactNumber: "联系电话：+86 13816726321",
    CHINALandline: "固定电话：+86 021 62713711",
    MALAYSIAOffice: "马来西亚公司",
    MALAYSIAAdress:
      "地址：Lot A020, level 1, Podium Level, Financial Park, Jalan Mardeka, 87000  Labuan, F.T. Malaysia ",
    MALAYSIAEmail: "邮箱：info@blacklocustcap.com",
    MALAYSIAPhone: "电话：+60 087 427745",
    aboutUs: "关于我们",
    requirements: "客户须知",
    policy: "隐私政策",
    terms: "使用条款与条件",
  },
  about: {
    title1:"一站式解决您所有财务需求",
    title2:"通过迅速和高效的解决方案，拓展您的业务需求，创造实质价值。",
    readMore: "阅读更多",
    collapsee: "收起",
    fullText1:
      "欢迎来到黑槐资本，专业知识与创新相结合。凭借对卓越金融的承诺，我们使个人和企业能够实现其财务目标。我们拥有经验丰富的专业人员和尖端金融技术确保为您提供无与伦比的服务，使我们成为您财务旅程中值得信赖的合作伙伴。通过我们为您量身定制的全方位解决方案，您将发现一个充满机遇的新世界。 在金融行业的前沿，我们努力追求卓越、诚信和客户满意度。加入我们，一起驾驭金融的未来。作为一家领先的金融服务提供商，我们为能提供全面的财务解决方案以满足客户的多样化需求而感到自豪。从个性化财富管理和投资咨询服务到创新的银行解决方案，我们将专业知识与技术相结合，推动财务目标健康成长。凭借对诚信和服务品质的承诺，我们努力为客户创造价值，培养建立在信任基础上的长期关系。前瞻性思维确保我们始终处于行业趋势的前沿，为客户提供应对复杂金融环境所需的工具和指导。",
    truncatedText1:
      "欢迎来到黑槐资本，专业知识与创新相结合。凭借对卓越金融的承诺，我们使个人和企业能够实现其财务目标。我们拥有经验丰富的专业人员和尖端金融技术确保为您提供无与伦比的服务，使我们成为您财务旅程中值得信赖的合作伙伴。通过我们为您量身定制的全方位解决方案，您将发现一个充满机遇的新世界。...",
    fullText2:
      "黑槐资本提供专业的私人基金管理服务，量身定制投资策略，以满足客户的独特财务目标。凭借全球视野性的运营架构和对金融市场的深入了解，我们提供个性化指导，以保护并增长合作伙伴的财富。此外，我们为客户在国际市场上可能遇到的各种商业挑战提供全面支持。 这包括关于驾驭文化细微差别、克服语言障碍和理解当地商业规则的指导。此外，我们在客户遇到的不同地区的法律、法规和合规事务的差异化方面提供专业知识。我们对全球市场和商业环境的广泛了解使我们能够提供有价值的见解，帮助客户在任何经营场所降低风险并迎接机遇。我们的目标是通过帮助客户应对采购，物流，海关报关和其它商业挑战，帮助他们高效地实现目标，从而提升客户的市场竞争优势。",
    truncatedText2:
      "黑槐资本提供专业的私人基金管理服务，量身定制投资策略，以满足客户的独特财务目标。凭借全球视野性的运营架构和对金融市场的深入了解，我们提供个性化指导，以保护并增长合作伙伴的财富。此外，我们为客户在国际市场上可能遇到的各种商业挑战提供全面支持。...",
  },
  home: {
    title1:"与黑槐",
    title2:"共筑未来",
    title3:"黑槐资本，通过创建推动未来经济的卓越企业，为投资者取得成功。",
    title: "我们的使命和目标",
    text1:
      "欢迎来到黑槐资本，在这里专业知识与创新相结合。凭借对卓越金融技术的承诺，我们帮助个人和企业实现他们的财务目标。我们经验丰富的专业人员和尖端的金融技术确保了无与伦比的服务，使我们成为您金融旅程中值得信赖的合作伙伴。通过我们为您量身定制的全方位解决方案，发现充满机遇的世界。在金融行业的最前沿，我们追求卓越、诚信和客户满意度。加入我们，让我们一起引领金融的未来。",
    readMore: "阅读更多",
    learnMore: "了解更多",
    number1: "$17.7亿",
    text2: "签约总额",
    date1: "数据截至2025年12月31日",
    text3: "我们的主要服务",
    text4: "银行授信担保",
    text5: "固定资产投资",
    text6: "数字资产投资",
    text7: "人工智能应用",
    text8: "专业知识",
    text9: "你将得到专家的专业数据和评估，帮助你建立强大的信托计划。",
    text10: "互相信赖",
    text11:
      " 如果您正在寻找一个值得信赖的合作伙伴，以满足您的投资需求，黑槐资本在这里随时恭候您的莅临。",
    text12: "量身定制",
    text13:
      " 我们清楚地知道您的每一项金融需求都是独一无二的，因此我们为客户量身定制融资和投资解决方案，以满足您的具体要求。",
    text14: "不懈努力",
    text14_1: "追求卓越",
    text15:
      "我们努力做到最好，依赖于我们的全球人才和广泛视野为我们的客户创造令人信服的成果。",
    text16: "客户需提供",
    text17:
      "团队专注于为黑槐资本寻找并追求新的业务机会。他们与潜在客户建立关系，探索合作伙伴关系，并为公司的增长和扩张计划做出贡献。",
    text18: "了解更多 >>",
  },
  homeUserNotice: {
    title1:"与黑槐",
    title2:"共筑未来",
    title3:"黑槐资本，通过创建推动未来经济的卓越企业，为投资者取得成功。",
    text1: "客户须知",
    text2:
      "黑槐要求寻求融资的潜在客户满足以下要求，以确保它们符合公司的融资标准和风险偏好。以下是向黑槐寻求融资的客户的潜在要求列表：",
    text3: "业务可行性：",
    text4:
      "客户应该有一个明确的商业计划，证明其业务的可行性和成功潜力。包括明确的价值主张、目标市场、收入预测和深思熟虑的商业模式。",
    text5: "财务稳定性：",
    text6:
      "客户应具有稳定的财务状况，有良好的信用记录和反映其经营业绩的财务报表。其中包括可靠的信用评分、正现金流和合理的债务水平。",
    text7: "抵押品或担保：",
    text8:
      "根据交易的性质，客户可能需要为融资或投资提供抵押品或担保。这可能包括房地产、存货、设备或其他可用作担保的有形资产。",
    text9: "行业经验：",
    text10:
      "客户应具有相关的行业经验和专业知识，以证明其有效管理和运营业务的能力。包括在行业或相关领域的成功记录。",
    text11: "增长潜力：",
    text12:
      "客户应该有一个明确的增长和扩张计划，并有扩大业务的愿景。包括其行业的市场扩张、多元化或创新潜力。",
    text13: "强大的管理团队：",
    text14:
      "客户应拥有一支有能力、经验丰富的管理团队，拥有成功的商业管理记录。包括推动业务成功所需的领导技能、行业知识和运营专业知识。",
    text15: "清晰的资金用途：",
    text16:
      "客户应对通过融资获得的资金的使用有明确的计划，并明确使用该资金实现业务目标的模式和策略。",
    text17: "风险评估：",
    text18:
      "客户应全面了解与其业务相关的风险，并证明其拥有有效管理的方法和对冲这些风险的能力。",
    text19: "法律和法规合规性：",
    text20:
      "客户应遵守其行业和管辖范围内的所有适用法律、法规和许可要求，并能够根据需要提供证明合规性的文件。",
    text21: "对合作的开放性：",
    text22:
      "客户应对与黑槐资本的合作持开放态度，包括定期提供销售业绩和财务报告的最新信息，并与黑槐团队密切合作以实现共同价值目标。",
    text23:
      "请注意，这些要求可能因具体融资需求而异，黑槐资本将会根据其内部政策和风险评估提出额外不同的要求。对于潜在客户来说，在向黑槐资本寻求融资之前，请仔细审查并了解融资需求的合理性与可执行性。",
    text24: "请通过以下电子邮件地址与我们联系：",
    text25: "info@blacklocustcap.com",
    text26: "您也可以通过我们网站",
    text27: "info@blacklocustcap.com",
    text28:
      "上的联系对话框与我们联系 我们期待着收到您的来信，并讨论黑槐资本如何满足您的潜在的融资和商业咨询需求。我们的团队随时准备为您提供服务，探索互惠互利的机会。",
  },
  homePrivacy:{
    title1:"与黑槐",
    title2:"共筑未来",
    title3:"黑槐资本，通过创建推动未来经济的卓越企业，为投资者取得成功。",
    text1:"隐私政策",
    text2:"在黑槐资本，我们非常重视客户信息的隐私和安全。本隐私政策概述了我们如何收集、存储和使用客户提供的个人信息，以及使用我们网站的条款和条件。",
    text3:"信息收集：",
    text4:"我们可以通过各种方式收集客户的个人信息，包括但不限于电话、电子邮件和面对面会议。这些信息可能包括姓名、地址、联系方式、财务信息以及提供我们服务所需的任何其他信息。",
    text5:"信息的使用：",
    text6:"我们仅将客户的个人信息用于提供我们的服务，未经客户同意，我们不会将这些信息分享或出售给任何第三方。我们可能会使用这些信息与客户沟通，向他们提供投资的最新信息，并遵守法律和监管要求。",
    text7:"信息存储：",
    text8:"我们采取适当措施保护客户的个人信息，包括维护物理、电子和程序保护措施，以防止未经授权的访问、使用或披露。我们保留个人信息的时间为实现我们的业务目的和遵守法律法规要求所必需的时间。",
    text9:"使用条款：",
    text10:"通过访问和使用我们的网站，您同意遵守这些使用条款。您不得将本网站用于任何非法或未经授权的目的。您有责任维护您的登录凭据的机密性，并负责您帐户下发生的任何活动。我们保留以任何理由随时终止或暂停访问本网站的权利。",
    text11:"隐私政策的更改：",
    text12:"我们可能会不时更新本隐私政策。本政策如有任何重大变更，我们将通过电子邮件或在我们的网站上发布通知通知您。",
    text13:"如果您对我们的隐私政策或使用条款有任何疑问或担忧，请通过联系我们",
    text14:"info@blacklocustcap.com",
  },
  homeTerms:
  {
    title1:"与黑槐",
    title2:"共筑未来",
    title3:"黑槐资本，通过创建推动未来经济的卓越企业，为投资者取得成功。",
    text1:"使用条款与条件",
    text2:"欢迎访问黑槐资本网站。访问和使用本网站即表示您同意遵守这些条款和条件。如果您不同意这些条款，请不要使用本网站。",
    text3:"知识产权：",
    text4:"我们网站上的所有内容，包括但不限于文本、图形、图像、徽标和软件，都是黑槐资本的财产，受版权法保护。未经我们事先书面同意，您不得复制、分发或修改任何内容。",
    text5:"网站使用：",
    text6:"您不得将本网站用于任何非法或未经授权的目的。您不得修改、改编或侵入本网站，也不得试图未经授权访问我们的系统。您有责任维护您的登录凭据的机密性，并负责您帐户下发生的任何活动。我们保留以任何理由随时终止或暂停访问本网站的权利。",
    text7:"责任限制：",
    text8:"黑槐资本对因使用或无法使用我们的网站或其中包含的信息而造成的任何损害不承担责任。我们不保证我们网站上任何信息的准确性、完整性或及时性。我们保留随时修改、暂停或终止网站任何方面的权利，恕不另行通知。",
    text9:"第三方网站链接：",
    text10:"我们的网站可能包含非黑槐资本所有或控制的第三方网页链接。我们不对这些网站的内容或隐私政策负责，并鼓励您在使用它们之前查看它们各自的条款和条件。",
    text11:"条款和条件的更改：",
    text12:"我们可能会不时更新这些条款和条件。如果这些条款发生任何重大变化，我们将通过电子邮件或在我们的网站上发布通知通知您。",
    text13:"适用法律：",
    text14:"本条款和条件应受阿拉伯联合酋长国法律管辖并根据其进行解释。由这些条款引起的或与之相关的任何争议均受迪拜法院的专属管辖。",
    text15:"如果您对我们的隐私政策或使用条款有任何疑问或担忧，请通过联系我们",
    text16:"info@blacklocustcap.com",
  },
  ourServices: {
    title:"我们的服务",
    learnMore: "了解更多",
    text1: "银行授信担保",
    text2: "固定资产投资",
    text3: "数字资产投资",
    text4: "人工智能应用",
  },
  ourServicesAi: {
    title:"人工智能应用",
    text1: "医疗AI助理",
    text2:
      "利用计算机视觉技术，医疗 AI 助理能够对 X 光、CT、MRI 等医学影像进行快速、精准的分析。通过自然语言处理技术，医疗 AI 助理可以与患者进行交互，了解患者的症状、病史、家族病史等信息。",
    text3: "快速诊断结果",
    text4: "个性治疗方案",
    text5: "助力药物研发",
    text6: "医疗教育培训",

    text7: "律师AI助理",
    text8:
      "基于大量的历史案例数据和当前案件的详细信息，律师 AI 助理可以协助律师进行快速判断。",
    text9: "案件信息管理",
    text10: "提高律师工作",
    text11: "法律研究法规",
    text12: "合同审查起草",

    text13: "元宇宙与体育",
    text14:
      "利用 3D 建模技术构建高度仿真的体育场馆。对于赛事场景，能够实时模拟比赛的进程。",
    text15: "虚拟场景赛事分析",
    text16: "虚拟运动员和观众",
    text17: "赛事体验互动分析",
  },
  ourServiceBank: {
    title:"银行授信担保",
    text1: "大宗贸易担保",
    text2: "备用信用证",
    // text3: "黑槐资本，代表我们的客户为 (SBLC) 的发行提供便利。在与客户密切合作以了解他们的具体需求的同时，我们提供量身定制的 (SBLC) 解决方案，以符合国际贸易的要求，同时与全球合作伙伴建立信任和信誉。通过提供抵押品管理、文件支持和专家咨询服务，我们旨在提高从事全球贸易的客户的财务灵活性和风险管理能力。",
    text3: "黑槐资本，代表我们的客户为",
    text4: "(SBLC)",
    text5:
      "的发行提供便利。在与客户密切合作以了解他们的具体需求的同时，我们提供量身定制的",
    text6: "(SBLC)",
    text7:
      "解决方案，以符合国际贸易的要求，同时与全球合作伙伴建立信任和信誉。通过提供抵押品管理、文件支持和专家咨询服务，我们旨在提高从事全球贸易的客户的财务灵活性和风险管理能力。",

    text8: "跟单信用证",
    text9: "我们通过提供",
    text10: "(DLC)",
    text11:
      "国际贸易安全交易方面发挥着关键作用。我们悉知到从事国际贸易的客户的不同需求，并提供量身定制的",
    text12: "(DLC)",
    text13:
      "解决方案，同时考虑到贸易协议和相关方的具体情况。我们整合了一系列服务，以无缝流程为客户提供便利，并在国际贸易法合规和规范文档、金融技术集成以及向客户提供贸易流程监控和报告交易状态方面提供帮助和指导。在黑槐资本，我们的目标是为客户提供信心和金融工具，这是进行安全和成功的跨境交易所必需的。",

    text14: "项目授信担保",
    text15: "履约保函",
    text16:
      "我们为自己的多样化服务感到自豪，并切身提供行动保证。与我们的其他服务一样，我们在抵押品管理、项目特定要求和债券有效期管理方面提供全面帮助。黑槐在向项目业主灌输信心、确保施工或项目合同按约定完成以及为项目利益相关者提供财务安全网方面发挥着至关重要的作用。",
    text17: "预付款保函",
    text18:
      "在众多工程或基建合同中，受益人可以要求提供预付款担保，作为向承包商提供预付款的条件。我们提供预付款担保，以确保项目业主的财务安全，尤其是在需要支付大量预付款的情况下。我们帮助建立合同各方之间的信任，并为大型项目的整体风险管理做出贡献。",
    text19: "资金证明",
    text20:
      "资金证明（POF）是证明可获得流动资金以完成交易或承担财务承诺的文件。我们通过各种方式协助客户提供资金证明，如银行对账单、银行验证函、保付支票或银行汇票以及投资组合对账单。资金证明的具体要求可能因交易的性质和所涉各方而异。我们与客户密切合作，了解要求并提供适当的文件以满足资金证明需求。",
    text21: "投标保证金",
    text22:
      "黑槐资本通过代表客户发行投标保证金，为参与竞标过程的承包商提供援助和金融工具。经过财务评估，我们根据客户的具体需求提供定制化的解决方案。我们协助抵押品管理、投标提交报告和管理债券的有效期。我们通过支持承包商追求项目，并为项目业主提供潜在违约的财务保证，确保促进公平透明的招标过程。",

    text23: "其他担保业务",
    text24: "RWA电文",
    text25:
      "黑槐资本提供的服务与确保一方“准备好、有愿意并有能力”履行其义务和承诺有关。无论是提供抵押贷款预审批服务、为贸易金融工具提供便利，还是评估项目可行性和构建融资解决方案，我们都会为客户提供全面的指导。",
    text26: "预先通知电文",
    text27:
      "黑槐资本专门为您的所有财务需求提供各种服务，包括预咨询信息。我们为贸易融资、SWIFT信息、传入电汇、外汇交易、贷款支付和证券交易提供预先通知信息。这些预先通知信息有助于我们与客户或交易对手之间的透明度、高效沟通和更好的协调。它使所有相关方都能充分了解情况，并为即将到来的财务活动做好准备。",
    text28: "资金锁定",
    text29:
      "我们为大额交易中的资金锁定提供服务。我们通过提供一系列服务来促进和管理暂时锁定的资金。这些服务包括托管服务（房地产/法律交易）、合规性、投资账户管理、文件和验证、风险管理以及资金发放。资金锁定服务旨在为各种金融交易提供透明度、安全性和合规性。无论是促进国际贸易、支持房地产交易还是管理投资账户，黑槐资本都在确保根据商定的条款有效锁定和释放资金方面发挥着至关重要的作用。",
  },
  ourServiceDigital: {
    title:"数字资产投资",
    text1: "沉浸式艺术展演",
    text2:
      "沉浸式艺术展演是一种将观众全方位包裹在艺术氛围中的展示形式。利用空间、灯光、音效、互动装置等多种元素，让观众能够全身心地投入到艺术体验中。观众不再是简单的旁观者，而是展演的一部分。",
    text3: "虚拟乐团表演",
    text4:
      "虚拟乐团表演是一种结合了数字技术与音乐表演的艺术形式。它主要是通过计算机图形技术创建虚拟形象，这些形象被设计成具有乐器演奏能力的乐团成员形象，然后按照预先编程或实时控制的方式进行音乐表演。虚拟乐团可以是完全虚构的，不存在真实的人类演奏者对应，也可以是在真实乐团基础上，利用虚拟形象来增强表演效果。",
    text5: "NPC短剧制作",
    text6:
      "NPC 短剧是一种新兴的短剧形式，其中 NPC（非玩家角色）原本常见于游戏领域，在短剧里则是指那些按照特定剧情设定和程序逻辑行动、说话的角色形象。这些短剧通常依托于特定的平台或应用程序，利用数字化技术构建虚拟场景与角色，以简短而紧凑的剧情吸引观众。",
    text7: "球幕大型演出",
    text8:
      "球幕演出是在球幕影院的基础上发展而来的。球幕影院通常是一个巨大的半球形屏幕，而球幕大型演出则是利用这个特殊的屏幕空间，结合灯光、音响、特效等多种手段进行的演出。观众置身其中，仿佛被演出内容包围。",
  },
  ourServiceFixed: {
    title:"固定资产投资",
    text1: "土地开发",
    text2: "阿塞拜疆巴库",
    text3:
      "巴库主城区的土地资源有限，因此具备很高的开发价值。当前可供开发的三 块土地拟用于建设高端住宅公寓或豪华公寓楼，可以吸引高收入人群和外籍买家。",
    text4:
      "主城区的土地成本和房地产价格较高，因此销售或出租的回报也较高。高端住宅、公寓、商业和办公楼的平均售价和租金都显著高于巴库的其他区域，确保了项目的盈利潜力。此外，巴库房地产市场相对稳定，特别是主城区需求强劲， 为投资者提供了相对稳定的回报预期。",
    text5: "高端住宅",
    text6: "公寓",
    text7: "商业地产",
    text8: "办公楼",

    text9: "酒店投资",
    text10: "市场定位与规划",
    text11: "对当地市场、宗教及习俗风俗活动情况具体分析，作出酒店发展定位。",
    text12: "选址考量",
    text13:
      "鉴于海外酒店投资的特殊性，要确保在选址、定位与服务等方面独具竞争力，以便于实现高利润回报。",
    text14: "规划与设计",
    text15:
      "中、高端商务酒店作为设计目标进行规划，同时加入中国的智能化酒店产业机器人。",
    text16: "建设与装修",
    text17: "充分了解当地宗教、风俗、气候等，进行建设规划。",
  },
  contact: {
    text1_1:"联系我们",
    adress: "地址：",
    email: "邮箱：",
    phone: "电话：",

    phoneNumber: "联系方式",
    DUBAIOffice: "迪拜公司",
    DUBAIAdress:
      "Villa 17, 31a St, Al Barsha 3,Dubai,UAE.",
    DUBAIEmail: "info@blacklocustcap.com",
    DUBAIPhone: "+971 43 865 810",

    CHINAOffice: "中国公司",
    CHINAAdress: "中国上海市南京西路1376号上海商城西栋527室",
    CHINAEmail: "info@blacklocustcap.com",
    CHINAContactPerson: "联系人：",
    Fred: "Fred",
    phoneNumber2: "联系电话：",
    CHINAContactNumber: "+86 13816726321",
    fixedPhone: "固定电话：",
    CHINALandline: "+86 021 62713711",

    MALAYSIAOffice: "马来西亚公司",
    MALAYSIAAdress:
      "Lot A020, level 1, Podium Level, Financial Park, Jalan Mardeka, 87000  Labuan, F.T. Malaysia ",
    MALAYSIAEmail: "info@blacklocustcap.com",
    MALAYSIAPhone: "+60 087 427745",

    text1: "让我们联系您",
    text2: "我们非常荣幸可以和您取得联系。填写此表格，我们会及时回复您的询问。",

    name: "姓名",
    firstName: "名字",
    lastName: "姓氏",
    advice: "意见或信息",
    submit: "提交",

    //中文看得见英文空白
    firstName_none: "名字",
    lastName_none: "",
    email_none: "",
    advice_none: "",
  },
  newsCenter: {
    title1:"黑槐资本出席成都迪拜投资合作推介会成功签署战略合作协议",
    date1:"2024-07-01",
    location1:"阿联酋迪拜",

    title2:"黑槐资本与利伯兰自由共和国签署投资备忘录",
    date2:"2024-06-07",
    location2:"阿联酋迪拜",

    title3:"黑槐资本三天密集拜会阿塞拜疆政府，共推3亿美元巴库投资计划",
    date3:"2025-04-09",
    location3:"阿塞拜疆",
    
    title4:"黑槐资本前往成都锦江区考察，共谋发展新篇章",
    date4:"2024-07-15",
    location4:"中国成都",

    // title5:"黑槐资本上海办事处盛大开业，开启创新发展新篇章",
    title5:"黑槐资本上海办事处盛大开业，开启创新发展新篇章",
    date5:"2024-07-13",
    location5:"中国上海",

    adress1:"中国上海",
    time1:"2025-03-18",
    content1top:"黑槐资本对话大成律所",
    content1down:"共话出海中东的机遇与挑战",
    adress2:"中国上海",
    time2:"2024-07-13",
    content2top:"黑槐上海办事处盛大开业",
    content2down:"开启创新发展新篇章",
    adress3:"阿联酋迪拜",
    time3:"2024-06-07",
    content3top:"黑槐资本&利伯兰自由共和国",
    content3down:"签署投资备忘录",
    adress4:"阿塞拜疆",
    time4:"2025-04-09",
    content4top:"黑槐资本&阿塞拜疆",
    content4down:"共推3亿美元投资计划",
    adress5:"中国成都",
    time5:"2024-07-15",
    content5top:"黑槐资本锦江区考察",
    content5down:"共谋合作新篇章",
    adress6:"阿联酋迪拜",
    time6:"2024-07-01",
    content6top:"出席成都迪拜合作推介会",
    content6down:"成功签署战略合作协议",
        adress7:"阿联酋迪拜",
    time7:"2025-08-18",
    content7top:"黑槐资本迪拜总部焕新启程",
    content7down:"开启全球战略新篇章",
 
  },
  newsCenterDetails1:{
    text1:"黑槐资本三天密集拜会阿塞拜疆政府",
    text2:"共推3亿美元巴库投资计划",
    text3:"2025-04-09",
    text4:"阿塞拜疆",
    text5:"黑槐资本执行总监Shahrukh Khan与董事兼大中华地区总经理Tony Zhang 率团，于4月9日至11日接连拜会阿塞拜疆政府机构，就投资 3亿美元推动巴库城市现代化及区域合作展开深入交流。",
    text6:"4月9日，代表团拜会巴库市市长埃尔达尔·阿齐佐夫，宣布启动3亿美元房地产开发项目，作为10亿美元投资计划的首阶段，聚焦基础设施升级、混合用途开发及智慧城市建设。阿齐佐夫表示欢迎，并承诺全力支持项目落地。",
    text7:"4月10日，代表团联同中国化工建筑第七局中东北非区总经理苏涛和中国建筑西南设计院阿联酋区域经理万思远，拜会阿塞拜疆国家城市规划与建筑委员会，受到第一副主席纳米克·胡马托夫接待。胡马托夫介绍了巴库及苏木盖特的发展规划，双方探讨了苏木盖特工业园区合作潜力。",
    text8:"4月11日，代表团访问阿塞拜疆共和国经济部，与经济部副部长阿纳尔·阿洪多夫会面。阿洪多夫分享了经济优先领域，黑槐资本重申投资愿景，双方就政策支持及项目推进达成共识。",
    text9:"黑槐资本表示，此行深化了与阿方的战略协作，将加速3亿美元项目实施，助力巴库及周边地区可持续发展，创造就业并提升国际竞争力。各方同意持续沟通，确保合作高效落地。",
    
  },
  newsCenterDetails2:{
    text1:"黑槐资本中国CEO张建荣与大成律所合伙人莫非律师",
    text2:"共话企业出海中东的机遇与挑战",
    text3:"2025-03-18",
    text4:"中国上海",
    text5:"近日，黑槐资本中国区首席执行官张建荣先生与大成律师事务所高级合伙人莫非律师就中国企业出海中东的热点问题展开深度对话。双方围绕全球化投资趋势、跨境法律合规及风险管理等议题分享了专业见解，为企业国际化战略提供了务实建议。",

  },
  newsCenterDetails3:{
    text1:"黑槐资本前往成都锦江区考察 共谋发展新篇章",
    text2:"2024-07-15",
    text3:"中国成都",
    text3_1:"近日，黑槐资本高层代表团赴成都市锦江区进行项目合作洽谈，并实地考察了相关产业园区及重点地块。双方就深化产业投资、文化娱乐创新等领域的合作展开深入交流，共同探索区域经济高质量发展新路径。",
    text4:"共商合作 擘画蓝图",
    text5:"在座谈会上，锦江区政府领导对黑槐资本一行的到访表示热烈欢迎，并详细介绍了锦江区的区位优势、产业规划及营商环境。锦江区作为成都市核心城区，正全力打造“国际消费中心城市核心区”和“现代服务业新高地”，期待与黑槐资本在金融投资、商业文旅、数字经济等领域开展深度合作，实现互利共赢。",
    text6:"黑槐资本执行董事Shahrukh Khan表示，锦江区资源禀赋突出、发展潜力巨大，公司高度重视与锦江区的战略合作，将充分发挥资本运作、产业整合等优势，结合区域发展规划，推动优质项目落地，助力锦江区产业升级与城市品质提升。",
    text6_1:"实地考察 精准对接",
    text7:"会后，黑槐资本团队在锦江区相关部门陪同下，实地考察了区内重点产业园区、商业载体及待开发地块，详细了解区域规划、基础设施配套及政策支持情况。双方就具体合作项目的可行性、实施路径等进行了务实探讨，为下一步合作奠定了坚实基础。",
    text8:"此次考察标志着黑槐资本与锦江区的合作进入实质性推进阶段。未来，双方将建立常态化沟通机制，加快推动项目落地，共同谱写高质量发展新篇章。",
  },
  newsCenterDetails4:{
   text1:"黑槐资本上海办事处盛大开业，开启创新发展新篇章",
   text2:"2024-07-13",
   text3:"中国上海",
   text4:"今日上午，黑槐资本上海办事处开业典礼在上海商城-波特曼酒店隆重举行。成都政府领导、多位行业嘉宾、合作伙伴及媒体代表等齐聚现场，共同见证这一重要时刻。典礼现场气氛热烈，掌声不断，标志着黑槐资本上海办事处正式扬帆起航，迈向高质量发展的新征程。",
   text5:"开业盛况：高朋满座，共襄盛举",
   text6:"上午11时，开业典礼在美妙的音乐声中拉开帷幕。黑槐资本CEO带领一众海外合作伙伴自远洋发来祝福，向莅临现场的各位嘉宾表示衷心感谢，并阐述了公司的创立初衷、发展愿景及战略规划。他表示：“黑槐资本将以客户需求为导向，致力于为客户提供优质的产品与服务，同时为行业发展贡献力量。”",
   text7:"随后，各位嘉宾领导上台致辞，对黑槐资本上海办事处的成立表示热烈祝贺，并对其未来发展寄予厚望。",
   text8:"",
   text9:"展望未来：创新引领，共赢发展",
   text10:"黑槐资本专注于金融服务，主营业务涵盖国际贸易融资和项目贸易融资等。公司汇聚了一批行业精英，拥有丰富的经验和实力，旨在通过持续创新为客户创造更大价值。典礼结束后，嘉宾们参观了公司办公环境，并对上海办事处的发展规划给予了高度评价。",
   text11:"未来，黑槐资本将秉持“诚信、创新、卓越、共赢”的核心价值观，与合作伙伴携手并进，为行业发展与社会进步贡献力量。",
   
  },
  newsCenterDetails5:{
    text1:"黑槐资本出席成都迪拜投资合作推介会",
    text2:"成功签署战略合作协议",
    text2_1:"2024-07-01",
    text3:"阿联酋迪拜",
    text4:"今日，由成都市人民政府与迪拜国际金融中心（DIFC）联合主办的“成都-迪拜投资合作推介会在“海湾明珠”迪拜举行。成都市青羊区和黑槐资本签订战略合作协议。黑槐资本将在成都设立常设机构，整合并引入数字文旅和金融资本等资源，在国际贸易、外商直接投资（FDI）、中企出海等方面与成都开展全方位合作。",
    text5:"共话合作机遇",
    text6:"此次推介会，成都市领导在致辞中强调，成都作为“一带一路”重要节点城市，正积极推动与阿联酋在低空经济、金融投资、电子信息和体育赛事等领域等领域的深度合作。",
  },
  newsCenterDetails6:{
     text1:"黑槐资本与利伯兰自由共和国签署投资备忘录",
     text2:"2024-06-07",
     text3:"阿联酋迪拜",
     text4:"2024年6月7日，利伯兰自由共和国总统维特·耶德利奇卡拜访黑槐资本迪拜公司，与黑槐资本商讨投资建设事宜。当日，维特·耶德利奇卡总统与黑槐资本执行总监Shahrukh Khan先生签署了投资备忘录，黑槐资本同意向利伯来自由共和国政府投资1500万欧元，用于建设一座五星级酒店及配套基础设施。",
  },
    newsCenterDetails7:{
     text1:"黑槐资本迪拜总部焕新启程 开启全球战略新篇章",
     text2:"2025-08-18",
     text3:"阿联酋迪拜",
     text4:"黑槐近日，黑槐资本在迪拜举行总部新址开业盛典，标志着其全球化战略布局进入一个全新的阶段。典礼现场嘉宾云集，气氛热烈，共同见证了这一重要里程碑。",
     text5:"本次开业盛典汇聚了来自黑槐资本全球各分公司，包括上海、马来西亚及新加坡的核心团队，彰显了公司内部的协同与团结。同时，众多迪拜本地的行业合作伙伴与重要客户代表也莅临现场，共同分享这一喜悦时刻，体现了黑槐资本在中东市场日益深厚的根基与广泛影响力。",
     text6:"活动上，黑槐资本CEO、股东代表及各部门经理发表了热情洋溢的致辞，他们回顾了公司的发展历程，并强调迪拜总部的升级是应对全球业务增长、深化本地服务的关键一步，未来将以此为枢纽，为区域客户提供更顶尖、更贴合的一站式金融解决方案。",
     text7:"在万众期待中，黑槐资本CEO与多位重要嘉宾共同为新办公室剪彩。这一仪式不仅象征着新空间的启用，更宣告了黑槐资本在迪拜乃至全球市场“焕新启程”的雄心。",
     text8:"紧随剪彩仪式后，活动还特别设置了RWA（真实世界资产）业务专题环节。 公司向与会嘉宾分享了在该领域的前瞻洞察与战略规划，并隆重宣布“迪拜RWA中心”正式成立，此举旨在引领中东地区资产通证化的创新浪潮。",
     text9:"尤为值得一提的是，知名专家吴大有博士在活动上，向黑槐资本赠送了其亲笔签名的著作《Web3金融革命：从PRE-RWA到RWA的全球资产通证化实战》，为庆典增添了浓厚的学术与行业交流色彩。",
     text10:"此次迪拜总部的新址的成功启航，是黑槐资本国际化征程中的重要一步。依托迪拜作为世界级金融与创新中心的独特优势，黑槐资本将继续携手全球合作伙伴，共同开创数字金融的未来。",
  },
  second:{
    text:"第二页",
  },
  third:{
    text:"第三页"
  },
  dialog:{
    close:"取消",
    confirm:"确定",
  }
};
